import React from "react";
import { useListContext } from "react-admin";
import { RaGrid } from "ra-compact-ui";
import ShowTitle from "../../../components/ShowTitle";
import {
  DatagridTextField,
  DatagridFunctionField,
  DatagridReferenceTextField,
} from "../../../components";

const LegalPersonTransactionalInfosIterator = () => {
  const { ids, data, basePath } = useListContext();

  return (
    <>
      <RaGrid item xs={12}>
        <ShowTitle title="Información transaccional" />
      </RaGrid>
      {ids.map((id, index) => (
        <RaGrid key={index} container item xs={12}>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="provinceId"
              reference="provinces"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="cityId"
              reference="cities"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="frequency"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="income"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="distributionChannelId"
              reference="distribution-channels"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="personCompanyBindingId"
              reference="person-company-bindings"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="trustId"
              reference="trusts"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="productId"
              reference="products"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="paymentMethodId"
              reference="payment-methods"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={6}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="purposeTransaction"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={6}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="sourceFunds"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="startingAmount"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="estimatedMonthlyAmount"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridFunctionField
              resource="legal-people"
              render={(record) => (record.transferAbroad ? "Sí" : "No")}
              source="transferAbroad"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="transferAbroadCountryId"
              reference="countries"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridFunctionField
              resource="legal-people"
              render={(record) => (record.transferFromAbroad ? "Sí" : "No")}
              source="transferFromAbroad"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="transferFromCountryId"
              reference="countries"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={12}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="address"
              id={id}
              data={data}
            />
          </RaGrid>
        </RaGrid>
      ))}
    </>
  );
};

LegalPersonTransactionalInfosIterator.defaultProps = {
  addLabel: true,
  data: {},
  ids: [],
};

export default LegalPersonTransactionalInfosIterator;
